import auth from "../../middlewares/auth";

export const supportRequestTypeRoutes = [
    {
        path: '/support-request-types',
        component: () => import(/* webpackChunkName: "request_type" */ '../../views/support_request_type/Index'),
        name: 'support_request_types',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['group-manage']
        }
    },
    {
        path: '/support-request-type/:id',
        component: () => import(/* webpackChunkName: "request_type" */ '../../views/support_request_type/RequestTypeForm'),
        name: 'update_support_request_type',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['group-manage']
        }
    },
    {
        path: '/create-support-request-type',
        component: () => import(/* webpackChunkName: "request_type" */ '../../views/support_request_type/RequestTypeForm'),
        name: 'create_support_request_type',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['group-manage']
        }
    },
    {
        path: '/support-request-type/:id/show',
        component: () => import(/* webpackChunkName: "request_type" */ '../../views/support_request_type/ViewGroup'),
        name: 'view_support_request_type',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['group-manage']
        }
    },
]